import axios from 'axios';

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const TURNSTILE_SITE_KEY = "0x4AAAAAACX5zPRry72pjXTd";

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Interceptor sends JWT token from login
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('adminToken');
    if (token) {
      config.params = config.params || {};
      config.params.token = token;  // Send JWT as 'token' param
    }
    return config;
  }
);
